import Cookies from "js-cookie";
import { signIn } from "@/api/customer";

const KEY_TOKEN = "kingdynasty_ec_token";

const getCustomerId = (token) => token && JSON.parse(atob(token.split(".")[1]))._id;

const getDefaultState = () => ({
  token: Cookies.get(KEY_TOKEN),
  customerId: getCustomerId(Cookies.get(KEY_TOKEN))
});

const state = getDefaultState();

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token;
  },
  SET_CUSTOMER_ID: (state, customerId) => {
    state.customerId = customerId;
  }
};

const actions = {
  async signIn({ commit }, data) {
    const { token } = await signIn(data);
    Cookies.set(KEY_TOKEN, token);
    commit("SET_TOKEN", token);
    commit("SET_CUSTOMER_ID", getCustomerId(token));
  },
  async signOut({ commit }) {
    Cookies.set(KEY_TOKEN, "");
    commit("SET_TOKEN", "");
    commit("SET_CUSTOMER_ID", "");
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};